import styles from "src/components/atoms/SearchInput/styles.module.css";
import cx from "classnames";
import { Msg, MsgProps } from "src/i18n/Msg";
import React from "react";
import SearchIcon from "src/assets/icons/search.svg";

type Props = {
  label?: MsgProps;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  defaultValue?: string;
  className?: string;
};

export const SearchInput: React.FC<Props> = ({
  label,
  value,
  onChange,
  placeholder,
  defaultValue,
  className,
}) => (
  <div className={styles.inputWrapper}>
    {label && (
      <label className={styles.label}>{label && <Msg {...label} />}</label>
    )}
    <div className={styles.inputContainer}>
      <img className={styles.rightIcon} src={SearchIcon} alt="search" />
      <input
        type={"text"}
        className={cx(styles.input, className)}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        placeholder={placeholder ?? ""}
      />
    </div>
  </div>
);
